module.exports = __webpack_public_path__ + "static/media/coralCover.3d285eb9.svg";